/* Lumaro — animated "plexus" backdrop: a slowly drifting network of points
   connected by lines when they're near each other, plus faint links toward
   the cursor. Purple, clean, low-density so it reads as premium texture and
   never competes with the product. Injects its own fixed, pointer-transparent
   canvas behind the page content (above the aurora glow layers). Only loaded
   on the product and collection templates (see layout/theme.liquid). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var canvas = document.createElement('canvas');
  canvas.className = 'lux-plexus';
  var st = canvas.style;
  st.position = 'fixed';
  st.top = '0';
  st.left = '0';
  st.width = '100%';
  st.height = '100%';
  st.zIndex = '-2';
  st.pointerEvents = 'none';
  st.opacity = '0';
  st.transition = 'opacity 1.2s ease';

  function start() {
    if (!document.body) { return; }
    document.body.appendChild(canvas);
    requestAnimationFrame(function () { st.opacity = '1'; });

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, pts = [], linkDist = 140, count = 60;
    var mouse = { x: -9999, y: -9999 };

    function resize() {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      linkDist = Math.min(150, Math.max(110, W / 12));
      // O(n^2) link pass, but the per-pair work is now just a squared
      // distance compare, so the original density is affordable again.
      count = Math.max(26, Math.min(66, Math.round((W * H) / 24000)));
      seed();
    }

    function seed() {
      pts = [];
      for (var i = 0; i < count; i++) {
        pts.push({
          x: Math.random() * W,
          y: Math.random() * H,
          vx: (Math.random() - 0.5) * 0.26,
          vy: (Math.random() - 0.5) * 0.26,
          r: Math.random() * 1.5 + 0.9
        });
      }
    }

    function step() {
      ctx.clearRect(0, 0, W, H);

      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < -20) p.x = W + 20; else if (p.x > W + 20) p.x = -20;
        if (p.y < -20) p.y = H + 20; else if (p.y > H + 20) p.y = -20;
      }

      // Links between nearby points.
      // Two things used to make this the most expensive thing on the page:
      // a Math.sqrt for every pair, and a separate beginPath/stroke per line
      // (hundreds of draw calls per frame). Now distances are compared squared,
      // and lines are bucketed into opacity bands so each band is one path and
      // one stroke — ~14 draw calls per frame instead of one per line (~300).
      // The band count is high enough that the fade reads as continuous.
      var maxSq = linkDist * linkDist;
      var BANDS = 14;
      var bands = [];
      for (var q = 0; q < BANDS; q++) bands.push([]);

      for (var a = 0; a < pts.length; a++) {
        var pa = pts[a];
        for (var b = a + 1; b < pts.length; b++) {
          var pb = pts[b];
          var dx = pa.x - pb.x, dy = pa.y - pb.y;
          var dSq = dx * dx + dy * dy;
          if (dSq < maxSq) {
            // Linear closeness, matching the original fade. One sqrt per
            // *linked* pair only (far fewer than per candidate pair).
            var t = 1 - Math.sqrt(dSq) / linkDist;
            var band = Math.min(BANDS - 1, (t * BANDS) | 0);
            bands[band].push(pa.x, pa.y, pb.x, pb.y);
          }
        }
      }

      ctx.lineWidth = 1;
      for (var q2 = 0; q2 < BANDS; q2++) {
        var seg = bands[q2];
        if (!seg.length) continue;
        ctx.strokeStyle = 'rgba(168,85,247,' + (((q2 + 0.5) / BANDS) * 0.34).toFixed(3) + ')';
        ctx.beginPath();
        for (var m = 0; m < seg.length; m += 4) {
          ctx.moveTo(seg[m], seg[m + 1]);
          ctx.lineTo(seg[m + 2], seg[m + 3]);
        }
        ctx.stroke();
      }

      // Cursor links — one path for all of them.
      var mDist = linkDist * 1.5;
      var mSq = mDist * mDist;
      ctx.strokeStyle = 'rgba(216,180,254,0.26)';
      ctx.beginPath();
      var drew = false;
      for (var c = 0; c < pts.length; c++) {
        var pc = pts[c];
        var mdx = pc.x - mouse.x, mdy = pc.y - mouse.y;
        if (mdx * mdx + mdy * mdy < mSq) {
          ctx.moveTo(pc.x, pc.y);
          ctx.lineTo(mouse.x, mouse.y);
          drew = true;
        }
      }
      if (drew) ctx.stroke();

      // Points — one fillStyle and one path for all of them.
      ctx.fillStyle = 'rgba(221,199,255,0.75)';
      ctx.beginPath();
      for (var k = 0; k < pts.length; k++) {
        var pp = pts[k];
        ctx.moveTo(pp.x + pp.r, pp.y);
        ctx.arc(pp.x, pp.y, pp.r, 0, Math.PI * 2);
      }
      ctx.fill();
    }

    var raf = null, running = false;
    // Full refresh rate: the drift is slow, so any frame cap reads as stutter.
    // The cost is kept down by the batching in step(), not by dropping frames.
    function loop() {
      step();
      raf = requestAnimationFrame(loop);
    }
    function play() {
      if (running) return;
      running = true;
      loop();
    }
    function stop() {
      running = false;
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    }

    resize();
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(resize, 200);
    });
    window.addEventListener('mousemove', function (e) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
    }, { passive: true });
    window.addEventListener('mouseout', function () {
      mouse.x = -9999; mouse.y = -9999;
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else if (!reduce) play();
    });

    if (reduce) {
      step(); // single static frame for texture, no animation
    } else {
      play();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
